/**
 * Method to generate a valid sku
 *
 * @param sku - sku as string or undefined
 * @param isPreselectDimension - a boolean that indicates if the sku is a preselected dimension
 * @returns - a sanitized sku (sku with 2 parts)
 */

export const getSanitizedSku = (sku: string, isPreselectDimension: boolean): string => {
  const parts = sku.split('-');
  const isLegacySku = parts.length > 2;
  const selectedLegacySku =
    isPreselectDimension && isLegacySku ? `${parts[0]}-${parts[1]}` : parts[0];
  return isLegacySku ? selectedLegacySku : sku;
};
